// External
import _ from "lodash";

// Internal
import {
  getGpaAssociatedDataRating,
  getFormattedGpaAssociatedRatingValue,
} from "../ratingPrimitives";
import { getValueBasedOnReportType } from "../reportTypeHelpers";

export const getGradePointCriteriaSet = ({
  ratings,
  termId,
  subjectId,
  criteriaSet,
  gpaExclusionMap,
  isFreezed,
  gpaInclusionMap,
}) => {
  // Get computed rating
  const computedRating = getGpaAssociatedDataRating({
    ratings,
    subjectId,
    termId,
  });

  // Currently overriding the grade point rating is not supported
  // const overRidingRating = getGpaAssociatedDataRating({
  //   computedRating: false,
  //   ratings,
  //   subjectId,
  //   termId,
  // });

  const rating = computedRating;

  const value = _.get(rating, "value", "-");

  const formattedValue = getFormattedGpaAssociatedRatingValue(value);

  const isNewGradingSetup = getValueBasedOnReportType();
  let isExcludedFromGPA = false;
  if (isNewGradingSetup) {
    const gpaIncludedSubjectOrCourseIds = _.map(gpaInclusionMap, item =>
      isFreezed
        ? item.subjectId ?? item.learningCourseId
        : item.subject?.id ?? item.learningCourse?.id
    );
    isExcludedFromGPA = !_.includes(gpaIncludedSubjectOrCourseIds, subjectId);
  } else {
    isExcludedFromGPA = isFreezed
      ? _.get(
          _.find(gpaExclusionMap, { subjectId }),
          "isExcludedFromGPA",
          false
        )
      : _.get(
          _.find(gpaExclusionMap, {
            subject: { id: subjectId },
          }),
          "isExcludedFromGPA",
          false
        );
  }
  return {
    ...criteriaSet,
    value: formattedValue,
    showAsteriskOnRating: isExcludedFromGPA,
  };
};
